import { render, staticRenderFns } from "./media-upload.vue?vue&type=template&id=4872419c&scoped=true"
import script from "./media-upload.vue?vue&type=script&lang=js"
export * from "./media-upload.vue?vue&type=script&lang=js"
import style0 from "./media-upload.vue?vue&type=style&index=0&id=4872419c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4872419c",
  null
  
)

export default component.exports